import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=2aedce79&scoped=true"
import script from "./entity.vue?vue&type=script&lang=js"
export * from "./entity.vue?vue&type=script&lang=js"
import style0 from "./entity.vue?vue&type=style&index=0&id=2aedce79&scoped=true&lang=css"
import style1 from "./entity.vue?vue&type=style&index=1&id=2aedce79&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aedce79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aedce79')) {
      api.createRecord('2aedce79', component.options)
    } else {
      api.reload('2aedce79', component.options)
    }
    module.hot.accept("./entity.vue?vue&type=template&id=2aedce79&scoped=true", function () {
      api.rerender('2aedce79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/components/entity.vue"
export default component.exports